import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';

const Service = ({
    registrationIdsSelected,
    isActiveFilter
}) => {

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [loadingItemPanel, setLoadingItemPanel] = useState(null);
    const [recordsItemByUserId, setRecordsItemByUserId] = useState(null);
    const [attributesDetailItemPanel, setAttributesDetailItemPanel] = useState(null);
    const [serviceIdSelected, setServiceIdSelected] = useState([]);

    const readOnlyAttributes = !(inserting || updating);

    const [id, setId] = useState(null);
    const [company, setCompany] = useState(null);
    const [name, setServiceName] = useState(null);
    const [price, setPrice] = useState(null);
    const [timePerService, setTimePerService] = useState(null);
    const [isActive, setIsActive] = useState('S');
    const [dtUpdate, setDtUpdate] = useState(null);
    const [username, setUsername] = useState(null);
    const [creationDate, setCreationDate] = useState(null);
    const [userCreation, setUserCreation] = useState(null);

    const attributeList = [
        { name: "id", value: id, setter: setId },
        { name: "company", value: company, setter: setCompany },
        { name: "serviceName", value: name, setter: setServiceName },
        { name: "price", value: price, setter: setPrice },
        { name: "timePerService", value: timePerService, setter: setTimePerService },
        {
            name: "isActive",
            value: isActive,
            setter: setIsActive,
            resetValue: 'S',
            checks: [
                {
                    field: 'isActive',
                    condition: 'VALUE_EQUALS',
                    arrayValue: ['S']
                }
            ]
        },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate },
        { name: "username", value: username, setter: setUsername },
        { name: "creationDate", value: creationDate, setter: setCreationDate },
        { name: "userCreation", value: userCreation, setter: setUserCreation }
    ];

    useEffect(() => {
        reloadListItem()
    }, []);

    useEffect(() => {
        reloadListItem()
    }, [registrationIdsSelected, isActiveFilter]);

    useEffect(() => {
        setInserting(false)
        setUpdating(false)
        setServiceIdSelected([])
    }, [isActiveFilter]);

    useEffect(() => {

        reloadListItem()

        if ((!serviceIdSelected || serviceIdSelected.length !== 1) && updating) {
            setUpdating(false)
        }

        if (!serviceIdSelected || serviceIdSelected.length > 1) {
            setServiceIdSelected([])
        }

    }, [serviceIdSelected, updating]);

    useEffect(() => {

        if (serviceIdSelected && serviceIdSelected.length === 1) {
            fetchDataDetail(serviceIdSelected[0]);
        } else {
            fetchDataDetail(null);
        }

    }, [serviceIdSelected]);

    const itemPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '83%'
    };

    async function reloadListItem() {

        const parameters = { isActive: isActiveFilter }

        const items = await ExecuteAxios.api(
            'get',
            `/service/grid/`,
            { params: parameters }
        );

        setRecordsItemByUserId(items);

        RemoveIdsNotFound.remove(
            items,
            setServiceIdSelected,
            serviceIdSelected
        );
    }

    const fetchDataDetail = async (serviceIdSelected) => {

        const parameters = {
            id: serviceIdSelected ? serviceIdSelected : 0
        }

        const item = await ExecuteAxios.api(
            'get',
            `/service/detail/`,
            { params: parameters }
        )

        if (item) {
            setAttributesDetailItemPanel(item)
            ApplyAttributes.applyAttributes(item, attributeList)
        }

        if (!serviceIdSelected || serviceIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    const getItemPanelListOrDetail = () => {

        if (!updating && !inserting) {

            return (
                <PanelListDefault
                    onUpdateIdSelected={setServiceIdSelected}
                    idsSelected={serviceIdSelected}
                    data={recordsItemByUserId}
                    attributeList={attributeList}
                />
            )
        }

        return (
            <AutomaticallyListedAttributes
                list={attributesDetailItemPanel}
                attributeList={attributeList}
                readOnlyAttributes={readOnlyAttributes}
            />
        )
    }

    async function postItem() {

        try {

            setLoadingItemPanel(true);

            const response = await ExecuteAxios.api(
                'post',
                `/service/`,
                {
                    company,
                    serviceName: name,
                    price,
                    timePerService,
                    isActive
                }
            );

            if (response) {
                await reloadListItem();
                setInserting(false);
            }

            return response;

        } finally {
            setLoadingItemPanel(false);
        }
    }

    async function putItem() {

        try {

            setLoadingItemPanel(true);

            const response = await ExecuteAxios.api(
                'put',
                `/service/`,
                {
                    id,
                    company,
                    serviceName: name,
                    price,
                    timePerService,
                    isActive
                }
            );

            if (response) {
                await reloadListItem();
                setUpdating(false);
            }

            return response;

        } finally {
            setLoadingItemPanel(false);
        }
    }

    return (
        <LoadingIndicator loaded={!loadingItemPanel}>
            <Panel
                style={itemPanelStyle}
                titlePage={'Serviços'}
                setUpdating={setUpdating}
                setInserting={setInserting}
                inserting={inserting}
                updating={updating}
                enableEdit={true}
                canEdit={
                    serviceIdSelected &&
                    serviceIdSelected.length === 1 &&
                    registrationIdsSelected &&
                    registrationIdsSelected.length === 1
                }
                putFunction={putItem}
                enableNewRecord={true}
                canNewRecord={
                    registrationIdsSelected &&
                    registrationIdsSelected.length === 1
                }
                postFunction={postItem}
                canViewCRUD={true}
                readOnly={false}
                recordsSelected={serviceIdSelected}
                viewOnlyOneRecordCRUD={true}
                resetVariables={() => {
                    ResetVariables.resetVariables(attributeList)
                }}
                dataListedAttributes={attributesDetailItemPanel}
                attributeList={attributeList}
                onUpdateIdSelected={setServiceIdSelected}
            >
                {getItemPanelListOrDetail()}
            </Panel>
        </LoadingIndicator>
    );

}

export default Service;